import axios from 'axios';

// 공개 상점 정보 (/api/config/store)
// main.js 가 라우트 이동마다 사이트 제목용으로 부르고 Footer 도 부르므로,
// 받은 값을 잠시(5분) 재사용한다. 관리자가 상점 정보를 바꾸면 새로고침 또는 5분 뒤 반영.
const CACHE_MS = 5 * 60 * 1000;
let storePromise = null;
let storedAt = 0;

export function getStoreConfig() {
  if (!storePromise || Date.now() - storedAt > CACHE_MS) {
    storedAt = Date.now();
    storePromise = axios.get('/api/config/store')
      .then(response => response.data || {})
      .catch(error => {
        // 실패한 응답은 재사용하지 않음
        storePromise = null;
        throw error;
      });
  }
  return storePromise;
}
